<app-anonymous-page-layout>
  <app-card>
    <app-page-title [title]="'PAGE.NOT_FOUND.TITLE' | translate" style="--page-title-padding-bottom: var(--size-xl)"></app-page-title>
    <div class="content">
      {{ 'PAGE.NOT_FOUND.DESCRIPTION' | translate }}
      <a class="link-primary" href="/">{{ 'PAGE.NOT_FOUND.TO_HOMEPAGE' | translate }}</a>
    </div>
  </app-card>
</app-anonymous-page-layout>
